<app-header></app-header>
<div class="columns is-vcentered is-centered">
    <div class="column">
        <img src="assets/version2/loginBanner.jpg" style="box-shadow:-20px 20px 0px 0px #5181FF; border-radius: 20px 20px 20px 20px;" alt="">
    </div>
    <div class="column">
        <div class="heading title is-2">Welcome Back</div>
        <div class="subHeading title is-6">Set a new password for your account.</div>
        <div class="loginFormCls">
            <form [formGroup]="resetform" id="resetform">
                <formly-form [model]="resetmodel" [fields]="resetfields" [options]="resetoptions" [form]="resetform">
                </formly-form>
            </form>
            <div class="loginCnt">
                <span style="visibility: hidden;">Don't have an account? <a href="javascript:void(0);">Signup</a></span>
                <div class="buttonCnt">
                    <button form="resetform" class="section-header button transparent-button"
                        (click)="changePassword()">{{'LblUpdate'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>